export const TEST_ID = 'prescriptionImportPage';

export const PRESCRIPTION_IMPORT_PAGE_ROUTE = '/data/prescriptions/new';

export const ACCEPT_FILE_TYPES = '.shp,.shx,.dbf,.prj,.zip';
